// src/views/InformationPublications/SingleFileUploader.tsx

import React, { useCallback } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { DeleteForever } from '@mui/icons-material';
import { useDropzone, DropEvent } from 'react-dropzone';

interface SingleFileUploaderProps {
  file: File | null;
  setFile: React.Dispatch<React.SetStateAction<File | null>>;
}

const SingleFileUploader: React.FC<SingleFileUploaderProps> = ({ file, setFile }) => {
  const onDrop = useCallback(
    (acceptedFiles: File[], _rejectedFiles: any[], _event: DropEvent) => {
      if (acceptedFiles.length > 0) {
        // pega apenas o primeiro
        setFile(acceptedFiles[0]);
      }
    },
    [setFile]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'application/pdf': ['.pdf'] }, 
    multiple: false,
    maxSize: 120 * 1024 * 1024,
  });

  const handleRemoveFile = (e: React.MouseEvent) => {
    e.stopPropagation();
    setFile(null);
  };

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: '2px dashed #6C1E8F',
        p: 2,
        textAlign: 'center',
        position: 'relative',
        cursor: 'pointer'
      }}
    >
      <input {...getInputProps()} />
      {!file ? (
        <>
          {isDragActive ? (
            <Typography variant="body1" color="primary">
              Solte o arquivo PDF aqui...
            </Typography>
          ) : (
            <Typography variant="body1">
              Arraste e solte um arquivo PDF aqui, ou clique para selecionar
            </Typography>
          )}
        </>
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
            {file.name}
          </Typography>
          <IconButton color="error" size="small" onClick={handleRemoveFile}>
            <DeleteForever fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default SingleFileUploader;